import { render, staticRenderFns } from "./A06.vue?vue&type=template&id=412c72f4&"
import script from "./A06.vue?vue&type=script&lang=js&"
export * from "./A06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "A06.vue"
export default component.exports